export const FULL_TEST_STEP_DURATIONS: Record<string, number> = {
  SPEAKING: 1800,
  WRITING: 1800,
  LISTENING: 1980,
  READING: 1800,
  BREAK1: 120,
  BREAK2: 120,
};

export const FULL_TEST_STEPS = ['SPEAKING', 'WRITING', 'BREAK1', 'READING', 'BREAK2', 'LISTENING'];

export const SECTION_TEST_STEP_DURATIONS: Record<string, Record<string, number>> = {
  Speaking: { SPEAKING: 2100 },
  Writing: { WRITING: 6300 },
  Listening: { LISTENING: 3780 },
  Reading: { READING: 4380 },
  RA: { RA: 2100 },
  RS: { RS: 2100 },
  DI: { DI: 2100 },
  RL: { RL: 2100 },
  WE: { WE: 1200 },
  SWT: { SWT: 600 },
  'FIB-RW': { 'FIB-RW': 2100 },
  'FIB-R': { 'FIB-R': 1800 },
  RO: { RO: 2460 },
  WFD: { WFD: 600 },
  SST: { SST: 600 },
  'FIB-L': { 'FIB-L': 2100 },
  HIW: { HIW: 2100 },
};

export const SECTION_TEST_STEPS: Record<string, string[]> = {
  Speaking: ['SPEAKING'],
  Writing: ['WRITING'],
  Listening: ['LISTENING'],
  Reading: ['READING'],
  RA: ['RA'],
  RS: ['RS'],
  DI: ['DI'],
  RL: ['RL'],
  WE: ['WE'],
  SWT: ['SWT'],
  'FIB-RW': ['FIB-RW'],
  'FIB-R': ['FIB-R'],
  RO: ['RO'],
  WFD: ['WFD'],
  SST: ['SST'],
  'FIB-L': ['FIB-L'],
  HIW: ['HIW'],
};
